// Modified TermlyCMP component:
'use client';

import { usePathname } from 'next/navigation';
import Script from 'next/script';
import { useEffect, useRef } from 'react';

export default function TermlyCMP({ websiteUUID, autoBlock = false, masterConsentsOrigin = null }) {
  const initialized = useRef(false);
  const pathname = usePathname();

  const termlyUrl = `https://app.termly.io/resource-blocker/${websiteUUID}${
    autoBlock ? '?autoBlock=on' : ''
  }${
    masterConsentsOrigin
      ? `${autoBlock ? '&' : '?'}masterConsentsOrigin=${masterConsentsOrigin}`
      : ''
  }`;

  useEffect(() => {
    if (!initialized.current && window?.Termly) {
      initialized.current = true;
      window.Termly.initialize();
    }
  }, [pathname]);

  return (
    <Script
      src={termlyUrl}
      strategy="lazyOnload"
      onLoad={() => {
        initialized.current = true;
        window?.Termly?.initialize();
      }}
    />
  );
}
